import { useQuery } from '@apollo/client/react';
import type { OrganizationsQueryVariables } from '@graphql/types';
import { OrganizationsDocument } from '@graphql/types/documents';
import { useCallback } from 'react';

import type { OrganizationsResponse } from '../types';

export const useGetOrganizations = () => {
  const { loading: isLoading, refetch: refetchOrgsQuery } = useQuery(OrganizationsDocument, {
    variables: {
      pagination: {
        first: 10,
      },
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    skip: true, // Don't run initial query - only fetch when explicitly called
  });

  const doGetOrganizations = useCallback(
    async (args?: OrganizationsQueryVariables): Promise<OrganizationsResponse> => {
      const { data } = await refetchOrgsQuery(
        args ?? {
          pagination: {
            first: 10,
          },
        }
      );
      const organizationsRes = data?.organizations;

      if (!organizationsRes) {
        throw new Error('Organization fetch failed');
      }

      return organizationsRes as OrganizationsResponse;
    },
    [refetchOrgsQuery]
  );

  return { doGetOrganizations, isLoading };
};
